/* ---------------------------------------------------------------------------
   MOBILE CHECKOUT FIX — added 2026-10-28

   Overrides the Accept Blue modal's own stylesheet. DEAD CODE once the modal is
   removed from main-cart-footer.liquid — the storefront no longer routes to it.
   --------------------------------------------------------------------------- */
(function () {
  var css =
    '@media only screen and (max-width: 768px){' +
    '#checkoutModal .modal-content{height:auto !important;max-height:calc(100vh - 20px) !important;}' +
    '#checkoutModal.modal{padding:10px !important;}' +
    '#checkoutModal .checkout-content{flex-direction:column-reverse !important;}' +
    '}';
  var s = document.createElement('style');
  s.id = 'mb-mobile-checkout-fix';
  s.appendChild(document.createTextNode(css));
  (document.head || document.documentElement).appendChild(s);
})();

/* ---------------------------------------------------------------------------
   DELIVERY CALENDAR VISIBILITY — v2, 2026-10-29

   Scrolls the page so the open date calendar is fully on screen. This calendar
   always opens ABOVE the field (top = fieldTop - 318), so it is clipped at the
   TOP, not the bottom; both directions are handled. Delegated on
   .delivery-date-field because Flatpickr runs with altInput (so #delivery-date
   is hidden and the tapped field has no id) and the picker is rebuilt whenever
   the customer switches Pickup <-> FedEx.
   --------------------------------------------------------------------------- */
(function () {
  function bringCalendarIntoView() {
    var cal = document.querySelector('.flatpickr-calendar.open');
    if (!cal) return;
    var r = cal.getBoundingClientRect();
    var target = null;
    if (r.bottom > window.innerHeight) {
      target = window.pageYOffset + (r.bottom - window.innerHeight) + 12;
    } else if (r.top < 0) {
      target = Math.max(0, window.pageYOffset + r.top - 12);
    }
    if (target === null) return;
    try { window.scrollTo({ top: target, behavior: 'smooth' }); }
    catch (e) { window.scrollTo(0, target); }
    setTimeout(function () {
      if (Math.abs(window.pageYOffset - target) > 4) window.scrollTo(0, target);
    }, 350);
  }
  function waitForCalendarThenScroll() {
    var tries = 0;
    (function check() {
      if (document.querySelector('.flatpickr-calendar.open')) { bringCalendarIntoView(); return; }
      if (++tries < 15) setTimeout(check, 50);
    })();
  }
  function onDateFieldTouched(e) {
    var t = e.target;
    if (t && t.closest && t.closest('.delivery-date-field')) waitForCalendarThenScroll();
  }
  document.addEventListener('focusin', onDateFieldTouched, true);
  document.addEventListener('click', onDateFieldTouched, true);
})();

/* ---------------------------------------------------------------------------
   SHIP GUARD — added 2026-10-30

   If any cart line has requires_shipping === false (Platinum Board, all of
   Yudi's Bites), disable FedEx, select Pickup / Local Delivery and say which
   item is responsible. Keyed on requires_shipping, not vendor, so new
   non-shippable products are covered with no edit here.
   --------------------------------------------------------------------------- */
(function () {
  var NOTICE_ID = 'mb-noship-notice';
  var css =
    '#' + NOTICE_ID + '{display:none;margin:10px 0 0;font-size:14px;line-height:1.45;color:#8a1f1f;}' +
    '#' + NOTICE_ID + '.show{display:block;}' +
    '.shipping-method-option.mb-option-disabled{opacity:.45;}' +
    '.shipping-method-option.mb-option-disabled label{cursor:not-allowed;}';
  var s = document.createElement('style');
  s.id = 'mb-ship-guard-style';
  s.appendChild(document.createTextNode(css));
  (document.head || document.documentElement).appendChild(s);

  function onCartPage() { return !!document.getElementById('method-fedex'); }

  function getNotice() {
    var el = document.getElementById(NOTICE_ID);
    if (el && el.isConnected) return el;
    var opts = document.querySelector('.shipping-method-options');
    if (!opts) return null;
    el = document.createElement('p');
    el.id = NOTICE_ID;
    opts.parentNode.insertBefore(el, opts.nextSibling);
    return el;
  }

  function phrase(names) {
    if (names.length === 1) return names[0];
    if (names.length === 2) return names[0] + ' and ' + names[1];
    return names[0] + ', ' + names[1] + ' and ' + (names.length - 2) + ' more';
  }

  function apply(blocked, names) {
    var fedex = document.getElementById('method-fedex');
    var pickup = document.getElementById('method-pickup');
    if (!fedex || !pickup) return;
    var wrap = fedex.closest('.shipping-method-option');
    var note = getNotice();
    if (blocked) {
      if (fedex.checked || !pickup.checked) {
        fedex.checked = false;
        pickup.checked = true;
        pickup.dispatchEvent(new Event('change', { bubbles: true }));
      }
      fedex.disabled = true;
      if (wrap) { wrap.classList.add('mb-option-disabled'); wrap.setAttribute('aria-disabled','true'); }
      if (note) {
        note.textContent = 'Pickup / Local Delivery only — ' + phrase(names) + ' cannot be shipped.';
        note.classList.add('show');
      }
    } else {
      fedex.disabled = false;
      if (wrap) { wrap.classList.remove('mb-option-disabled'); wrap.removeAttribute('aria-disabled'); }
      if (note) { note.classList.remove('show'); note.textContent = ''; }
    }
  }

  var inFlight = false;
  function check() {
    if (!onCartPage() || inFlight) return;
    inFlight = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bad = (cart.items || []).filter(function (i) { return i.requires_shipping === false; });
        apply(bad.length > 0, bad.map(function (i) { return i.product_title || i.title; }));
      })
      .catch(function () {})
      .then(function () { inFlight = false; });
  }

  var timer;
  function schedule() { clearTimeout(timer); timer = setTimeout(check, 250); }

  function start() {
    if (!onCartPage()) return;
    check();
    try { new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'shipping-method') schedule();
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(start, 0); });
  } else { setTimeout(start, 0); }
})();

/* ---------------------------------------------------------------------------
   CHECKOUT GATES — rewritten 2026-11-03, revised same day

   REPLACES the behaviour that was the biggest single cause of "I can't check
   out". Previously the Check out button was set disabled + pointer-events:none
   whenever the Shipping Policy box was unticked, no delivery method was
   preselected, and tapping the dead button did NOTHING — the click never
   reached an element, so there was no message, no highlight, no scroll.
   Measured on a 375x812 phone: the button sat at y=1153 on a 2453px page, so
   the customer scrolled three screens, tapped a grey button, and was told
   nothing.

   NOW: the button is never disabled while the cart has items; on click we name
   the first unmet requirement, right next to the button, and move the page as
   little as possible.

   THE "IT JUMPS TO THE TOP" BUG (reported by Hannah, 2026-11-03): the first
   version scrolled the first unmet requirement to the CENTRE of the screen
   with scrollIntoView({block:'center'}). On a phone the method message sits at
   y=1059 and the button at y=1153, so a tap threw the page ~1000px upward.
   The red message was then at the very bottom edge of the screen, so the only
   thing the customer registered was the jump. Two changes: the page now moves
   only when the target is actually off screen, and by the shortest distance
   ('nearest'); and a single summary line is printed immediately above the
   button, where the customer's eye already is.

   THE THEME SHOWS ITS ERRORS TOO EARLY: main-cart-footer.liquid runs its own
   validateForm() during init, which puts "Please select a shipping method to
   continue." in red on the page before the customer has touched anything. We
   hold every message back until the first checkout attempt (`attempted`), so
   red text means "you tried and something is missing", not "hello".

   WHY ONE MESSAGE AT A TIME, NOT ALL THREE: main-cart-footer.liquid already
   stages this form — `.delivery-date-wrapper { display: none }` hides the date
   picker until a method is chosen. Listing a missing date while its field is
   still hidden is noise. So the checks run in the order the form reveals them.

   REUSES the theme's own message elements rather than adding new ones:
     #method-error  (.method-validation-message) — already in the markup
     #date-error    (.date-validation-message)   — already in the markup
     #policy-error        — created here, added 2026-10-22
     #mb-checkout-error   — created here, the summary line beside the button
   A first attempt added a second method message and produced two lines saying
   the same thing. Check the Liquid before inventing an element.

   Shopify's own `{% if cart == empty %}disabled{% endif %}` is left alone — an
   empty cart SHOULD have a dead button.

   This block owns validation; NATIVE CHECKOUT SWITCH calls
   window.mbCartGates.validate() rather than repeating the rules.
   --------------------------------------------------------------------------- */
(function () {
  /* No red text until the customer has actually tried to check out. */
  var attempted = false;

  function policyError() {
    var el = document.getElementById('policy-error');
    if (el && el.isConnected) return el;
    var box = document.getElementById('shipping-policy-checkbox');
    if (!box) return null;
    el = document.createElement('p');
    el.id = 'policy-error';
    el.className = 'date-validation-message';
    el.textContent =
      'Please tick the box above to agree to the Shipping Policy before checking out.';
    (box.closest('.cart-policy-confirmation') || box.parentElement).appendChild(el);
    return el;
  }

  /* The summary line, immediately above the Check out button. The per-field
     messages are 300-400px up the page; on a phone that is off screen when the
     button is tapped. This is the one the customer actually sees. */
  function summaryEl() {
    var el = document.getElementById('mb-checkout-error');
    if (el && el.isConnected) return el;
    var ctas = document.querySelector('.cart__ctas');
    if (!ctas) return null;
    el = document.createElement('p');
    el.id = 'mb-checkout-error';
    el.className = 'date-validation-message';
    el.style.textAlign = 'center';
    el.style.margin = '0';          /* .cart__ctas is a column flex with a 10px gap */
    ctas.insertBefore(el, ctas.firstChild);
    return el;
  }

  function setSummary(text) {
    var el = summaryEl();
    if (!el) return;
    if (text) {
      el.textContent = text;
      el.classList.add('show');
    } else {
      el.classList.remove('show');
      el.textContent = '';
    }
  }

  /* THE POLICY BOX MOVE — 2026-11-03, at Hannah's request. In Liquid the box
     sits between the delivery block and the Check out button: the last thing
     on a three-screen page, which is why customers missed it and then could
     not check out. It belongs above the delivery block, met before the date.

     WHY THIS IS NOT A ONE-LINE insertBefore: the first version was, and it
     looked right — until a quantity change, after which the policy box was
     GONE from the page entirely and checkout ran with no policy gate at all.
     The delivery block lives inside .js-contents, and a cart update replaces
     that container's innerHTML wholesale with freshly rendered Liquid. The
     policy box is a sibling of .js-contents in Liquid, so moving it in meant
     moving it into the container that gets wiped, and the replacement markup
     never contained it.

     So: keep a clone of the Liquid-rendered element, and after any re-render
     put a fresh copy back where it belongs. The wording still comes from
     Liquid (captured on load), so editing the text there is all it takes.
     Idempotent — re-entry via the observer stops at the early return. */
  var policyTemplate = null;
  var policyWasChecked = false;

  function rememberPolicy() {
    var box = document.getElementById('shipping-policy-checkbox');
    if (box) policyWasChecked = box.checked;
  }

  function restorePolicy() {
    var box = document.getElementById('shipping-policy-checkbox');
    if (box && policyWasChecked && !box.checked) box.checked = true;
  }

  function placePolicyAboveDelivery() {
    var delivery = document.querySelector('.cart__gift-options');
    if (!delivery || !delivery.parentNode) return;

    var policy = document.querySelector('.cart-policy-confirmation');
    if (policy) {
      if (!policyTemplate) policyTemplate = policy.cloneNode(true);
      if (delivery.previousElementSibling === policy) return;
    } else if (policyTemplate) {
      policy = policyTemplate.cloneNode(true);   /* wiped by a cart re-render */
    } else {
      return;
    }

    delivery.parentNode.insertBefore(policy, delivery);
    restorePolicy();
  }

  function show(el, on) { if (el) el.classList.toggle('show', !!on); }

  /* Move the page only if the target is off screen, and then by the shortest
     distance. Never re-centre something the customer can already see — that is
     what read as "the button threw me to the top of the page". */
  function scrollIfNeeded(el) {
    if (!el || !el.getBoundingClientRect) return;
    var r = el.getBoundingClientRect();
    if (!r.height && !r.width) return;                 /* hidden: nothing to show */
    var h = window.innerHeight || 0;
    if (r.top >= 60 && r.bottom <= h - 60) return;     /* comfortably in view already */
    var before = window.pageYOffset;
    try { el.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }
    catch (e) { el.scrollIntoView(); }
    /* behavior:'smooth' is a silent no-op in some contexts (measured: it moved
       the page 0px where the instant call moved it 271px). Verify, then fall
       back — the same trap the calendar fix hit on 2026-10-29. */
    setTimeout(function () {
      if (Math.abs(window.pageYOffset - before) >= 4) return;
      var rr = el.getBoundingClientRect();
      var hh = window.innerHeight || 0;
      if (rr.top < 60 || rr.bottom > hh - 60) {
        try { el.scrollIntoView({ block: 'nearest' }); } catch (e2) { el.scrollIntoView(); }
      }
    }, 400);
  }

  /* Checks run in the order the form reveals them. Returns true when the cart
     is ready to check out. */
  function validate(reveal) {
    var method = document.querySelector('input[name="shipping-method"]:checked');
    var date = document.getElementById('delivery-date');
    var policy = document.getElementById('shipping-policy-checkbox');

    var mErr = document.getElementById('method-error');
    var dErr = document.getElementById('date-error');
    var pErr = reveal ? policyError() : document.getElementById('policy-error');

    if (!method) {
      if (reveal) {
        attempted = true;
        show(mErr, true);
        setSummary('Choose Pickup / Local Delivery or FedEx Shipping above.');
        scrollIfNeeded(mErr);
      }
      return false;
    }
    if (!date || !date.value) {
      if (reveal) {
        attempted = true;
        show(dErr, true);
        setSummary('Choose a delivery or pickup date above.');
        scrollIfNeeded(dErr);
      }
      return false;
    }
    if (policy && !policy.checked) {
      if (reveal) {
        attempted = true;
        show(pErr, true);
        setSummary('Tick the Shipping Policy box above to continue.');
        scrollIfNeeded(pErr);
      }
      return false;
    }
    setSummary('');
    return true;
  }

  /* Clear each message the moment its requirement is met — never leave red text
     beside something the customer has already done. Before the first attempt,
     clear all of them: this is also what undoes the theme's own validateForm(),
     which shows the method message during init. */
  function sync() {
    var mErr = document.getElementById('method-error');
    var dErr = document.getElementById('date-error');
    var pErr = document.getElementById('policy-error');

    if (!attempted) {
      show(mErr, false);
      show(dErr, false);
      show(pErr, false);
      setSummary('');
      return;
    }

    var method = document.querySelector('input[name="shipping-method"]:checked');
    var date = document.getElementById('delivery-date');
    var policy = document.getElementById('shipping-policy-checkbox');
    if (method) show(mErr, false);
    if (date && date.value) show(dErr, false);
    if (policy && policy.checked) show(pErr, false);
  }

  /* The theme's validateForm() sets checkoutButton.disabled = !ok on every
     change, so this has to run AFTER it, not just before — hence the deferred
     second pass in the listener below and the attribute observer. */
  function liveButton() {
    var btn = document.querySelector('button.cart__checkout-button[name="checkout"]');
    if (!btn) return;
    if (document.querySelector('.cart__empty-text, .is-empty')) return;
    if (btn.disabled) btn.disabled = false;
    if (btn.style.opacity) btn.style.opacity = '';
    if (btn.style.pointerEvents) btn.style.pointerEvents = '';
  }

  function refresh() { liveButton(); sync(); }

  function start() {
    if (!document.getElementById('method-fedex')) return;
    placePolicyAboveDelivery();
    refresh();

    /* The theme initialises on its own schedule; re-assert for a moment after
       load so its eager error message and disabled button do not stick. */
    [0, 150, 400, 900, 1500].forEach(function (ms) { setTimeout(refresh, ms); });

    ['change', 'input'].forEach(function (evt) {
      document.addEventListener(evt, function () {
        rememberPolicy();
        setSummary('');                     /* stale the moment anything changes */
        refresh();
        setTimeout(refresh, 0);             /* again, after the theme's handler */
      }, true);
    });

    try {
      new MutationObserver(function () {
        placePolicyAboveDelivery();
        liveButton();
      }).observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['disabled', 'style']
      });
    } catch (e) {}
  }

  window.mbCartGates = { validate: validate };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(start, 0); });
  } else { setTimeout(start, 0); }
})();

/* ---------------------------------------------------------------------------
   CART RE-RENDER REPAIR — added 2026-11-03

   A LIVE CHECKOUT BLOCKER, found while testing the policy move and confirmed
   on the published site the same day. Steps on a phone:

     1. open /cart, choose FedEx Shipping  -> the date picker appears. Fine.
     2. press + or - on the quantity
     3. choose FedEx Shipping again        -> NOTHING HAPPENS. Ever.

   The date picker never comes back, so no date can be chosen, so checkout is
   impossible until the customer reloads the page — which nobody thinks to do.
   Anyone who adjusts a quantity in their cart is stuck.

   WHY: a quantity change makes Dawn replace the innerHTML of .js-contents with
   freshly rendered Liquid. The delivery block lives in there, so every radio,
   label and input in it is destroyed and recreated. The theme's own script in
   main-cart-footer.liquid captured those elements by reference at page load
   (var methodError = document.getElementById('method-error'), and the same for
   the radios and the date field) and binds its handlers directly to them. After
   the swap those references point at detached nodes, and the new controls have
   no handlers at all. Flatpickr is destroyed with them and never re-created.

   THE FIX IS A RELOAD, DELIBERATELY. Re-binding by hand would mean
   re-implementing the delivery rules — FedEx vs pickup minimum dates, the
   blocked-date metaobjects, weekend exclusions, the Ship By Date arithmetic —
   a second time, in a second place, where they could drift out of step with
   the Liquid. Those rules are the part of this cart that must not be got
   wrong. A reload hands the job back to the theme's own code, which builds the
   form correctly every time.

   Nothing is lost that was not already lost: the re-render clears the chosen
   method and date regardless, which is why they are gone after a reload too.

   Detection is the delivery block's node identity, not an event: Dawn fires
   nothing reliable here. `reloading` makes it strictly one reload per page
   load, so a page where the block is rebuilt repeatedly can never loop.

   MIN_AGE_MS DELAYS the reload, it does not cancel it. An earlier version
   returned early inside that window, which left a hole: a customer who taps +
   within a second and a half of the page appearing — not unusual — would get
   no reload and the dead form. The guard exists only so that a replacement
   during page setup does not reload the page out from under someone who has
   just arrived; the repair still happens, a beat later.
   --------------------------------------------------------------------------- */
(function () {
  var MIN_AGE_MS = 1500;
  var loadedAt = Date.now();
  var known = null;
  var reloading = false;

  function tick() {
    var block = document.querySelector('.cart__gift-options');
    if (!block) return;
    if (known === null) { known = block; return; }
    if (block === known) return;

    known = block;
    if (reloading) return;
    reloading = true;

    var wait = MIN_AGE_MS - (Date.now() - loadedAt);
    if (wait > 0) setTimeout(function () { window.location.reload(); }, wait);
    else window.location.reload();
  }

  function start() {
    if (!document.getElementById('method-fedex')) return;
    tick();
    try {
      new MutationObserver(tick).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(start, 0); });
  } else { setTimeout(start, 0); }
})();

/* ---------------------------------------------------------------------------
   NATIVE CHECKOUT SWITCH — added 2026-11-03

   Sends the cart to Shopify's own checkout instead of the Accept Blue modal.
   DELETE THIS BLOCK to put the modal back.

   #openModalBtn2 is type="button", not submit, so it never posted the cart
   form; its handler clicked the hidden #openModalBtn that Accept Blue binds to.
   The listener below is on document in the CAPTURE phase because a listener on
   the button itself would not win — at the target phase listeners fire in
   registration order, and the theme's inline script registers during parse,
   before this deferred file runs.

   THE DELIVERY DATE TRAP: #delivery-date has no name and no form="cart", so it
   never posted. The "Delivery Date" attribute on past orders was written by the
   Accept Blue modal. Without the hidden input below, every native-checkout
   order would arrive with no delivery date.
   --------------------------------------------------------------------------- */
(function () {
  function cartForm() { return document.getElementById('cart'); }

  function deliveryDateAttr() {
    var el = document.getElementById('mb-delivery-date-attr');
    if (el && el.isConnected) return el;
    var form = cartForm();
    if (!form) return null;
    el = document.createElement('input');
    el.type = 'hidden';
    el.id = 'mb-delivery-date-attr';
    el.name = 'attributes[Delivery Date]';
    el.setAttribute('form', 'cart');
    form.appendChild(el);
    return el;
  }

  function syncAttributes() {
    var src = document.getElementById('delivery-date');
    var dest = deliveryDateAttr();
    if (src && dest) dest.value = src.value || '';
  }

  function goToCheckout(e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    /* Validation lives in CHECKOUT GATES above — one set of rules, one place. */
    if (window.mbCartGates && !window.mbCartGates.validate(true)) return;

    syncAttributes();

    var form = cartForm();
    if (!form) return;
    if (!form.querySelector('input[name="checkout"]')) {
      var go = document.createElement('input');
      go.type = 'hidden';
      go.name = 'checkout';
      go.value = '';
      form.appendChild(go);
    }
    form.submit();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('#openModalBtn2')) goToCheckout(e);
  }, true);
})();

/* ---------------------------------------------------------------------------
   BILLING "SAME AS SHIPPING" — added 2026-10-29

   Applies to the Accept Blue modal only. DEAD CODE now that checkout is
   Shopify's own, which handles billing natively. Left in place until the modal
   is removed from main-cart-footer.liquid, then delete both together.
   --------------------------------------------------------------------------- */
(function () {
  var SHIP_TO_BILL = {
    firstName: 'billingFirstName',
    lastName: 'billingLastName',
    address1: 'billingAddress1',
    address2: 'billingAddress2',
    city: 'billingCity',
    country: 'billingCountry',
    zip: 'billingZip',
    phone: 'billingPhone'
  };

  function mirror() {
    var box = document.getElementById('billingSameAsShipping');
    if (!box || !box.checked) return;
    Object.keys(SHIP_TO_BILL).forEach(function (shipId) {
      var from = document.getElementById(shipId);
      var to = document.getElementById(SHIP_TO_BILL[shipId]);
      if (from && to) to.value = from.value;
    });
    if (typeof populateStateDropdown === 'function') {
      try { populateStateDropdown('billingCountry', 'billingState'); } catch (e) {}
    }
    var st = document.getElementById('state');
    var bst = document.getElementById('billingState');
    if (st && bst) bst.value = st.value;
  }

  function start() {
    var box = document.getElementById('billingSameAsShipping');
    if (!box) return;
    box.checked = true;
    box.dispatchEvent(new Event('change', { bubbles: true }));
    Object.keys(SHIP_TO_BILL).concat(['state']).forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.addEventListener('input', mirror);
      el.addEventListener('change', mirror);
    });
    var next = document.getElementById('nextBtn');
    if (next) next.addEventListener('click', mirror, true);
    mirror();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(start, 0); });
  } else { setTimeout(start, 0); }
})();
